import { Reveal } from "@/components/site/Reveal";
import { LeadForm } from "@/components/site/LeadForm";

export default function Book() {
  return (
    <div className="pt-32 pb-24 px-5 sm:px-8">
      <div className="max-w-[1300px] mx-auto grid lg:grid-cols-[0.85fr_1.15fr] gap-14 lg:gap-20">
        <div className="lg:sticky lg:top-28 self-start">
          <Reveal><p className="text-xs uppercase tracking-[0.3em] text-forest mb-6">Check your date</p></Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05]">
              Tell me about your <em className="text-forest">celebration.</em>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-ink/60 text-lg mt-6 max-w-md leading-relaxed">
              Fill this out and you'll get an instant confirmation email. I'll personally follow up within 24 hours with availability and a flat quote.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 space-y-4 text-sm">
              {["30% deposit locks your date", "Balance due 14 days before", "One free reschedule with 14 days notice"].map((x) => (
                <div key={x} className="flex items-center gap-3 text-ink/60">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest" /> {x}
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="rounded-3xl border border-clubborder bg-clubmuted/50 p-6 sm:p-10">
            <LeadForm />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
